const isDev = process.env.NODE_ENV !== "production";

// Verbose logs (log / info / debug) are emitted only in development so the
// production console stays clean. Warnings and errors always surface so prod
// issues remain diagnosable. To temporarily debug in prod, flip FORCE_PROD_LOGS.
const FORCE_PROD_LOGS = false;
const verbose = isDev || FORCE_PROD_LOGS;

const logger = {
  log: (...args) => verbose && console.log(...args),
  info: (...args) => verbose && console.info(...args),
  debug: (...args) => verbose && console.debug(...args),
  warn: (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};

export default logger;
